export const ENV = process.env.VUE_APP_ENV
export const API = process.env.VUE_APP_API
export const SIM = process.env.VUE_APP_SIM
export const COPYRIGHT = process.env.VUE_APP_COPYRIGHT || '&copy;' + new Date().getFullYear()
export const GMAP_KEY = process.env.VUE_APP_GMAP_KEY
export const GA = process.env.VUE_APP_GA

export const THEME_PORTAL = {
  primary: '#613b88',
  secondary: '#FF0000',
  judul: '#4d78af',
  subjudul: '#6d9dcd',
  accent: '#2D1CE8',
  error: '#f44336',
  warning: '#ffeb3b',
  info: '#2196f3',
  success: '#4caf50',
  background: '#edeaf7',
}

export const THEME_PORTAL_DARK = {
  primary: '#424242',
  secondary: '#ffffff',
  judul: '#212121',
  subjudul: '#757575',
  accent: '#0D47A1',
  error: '#f44336',
  warning: '#ffeb3b',
  info: '#2196f3',
  success: '#4caf50',
}
